import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import {
  Card,
  CardProps,
  Col,
  Container,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap';
import { AvatarParams } from '../Avatar/Avatar';
import AvatarGroup, {
  AvatarGroupSize,
  AvatarGroupStyle,
} from '../Avatar/AvatarGroup';
import CircledIcon from '../CircledIcon/CircledIcon';

export type customExpandableCardProps = CardProps & {
  title?: string;
  subtitle?: string;
  cardIcon?: IconProp;
  avatars: AvatarParams[];
  iconOnClick: (name: string) => void;
};

const ExpandableCard = ({
  title,
  subtitle,
  cardIcon,
  avatars,
  iconOnClick,
}: customExpandableCardProps) => {
  const [show, setShow] = useState(false);

  const handleOnClick = () => {
    setShow(!show);
  };

  return (
    <Container
      className={`expandable-card-custom p-0 m-0 ${show ? 'expanded' : ''}`}
    >
      <Card className={`expandable-card`} onClick={handleOnClick}>
        <Card.Body>
          <Card.Title>
            <Row className="m-0">
              <Col className="card-icon col-3">
                <CircledIcon variant="icon-emphasized" icon={cardIcon} />
              </Col>

              <Col className="col-9 px-7">
                <h5 className="text-fs-5 fw-light mb-1">{title}</h5>
                <Card.Subtitle className="card-subtitle">
                  {subtitle}
                </Card.Subtitle>
              </Col>
            </Row>
          </Card.Title>
          <Card.Body className="card-content mt-10">
            <AvatarGroup
              avatars={avatars}
              groupSize={AvatarGroupSize.DEFAULT}
              groupStyle={AvatarGroupStyle.STACKED}
            />
            <span className={`${show ? 'expand-arrow' : 'collapse-arrow'}`}>
              <FontAwesomeIcon icon={light('chevron-down')} />
            </span>
          </Card.Body>
        </Card.Body>
      </Card>
      <Card className={`hidden-expandable-card ${show ? 'expand' : 'hide'}`}>
        <Card.Body className="hidden-expand-body">
          <OverlayTrigger
            placement={'bottom'}
            overlay={
              <Tooltip className="expandable-card-tooltip">Phone</Tooltip>
            }
          >
            <div className="expand-body-icons">
              <FontAwesomeIcon
                color="white"
                icon={light('phone')}
                onClick={() => iconOnClick('phone')}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement={'bottom'}
            overlay={<Tooltip>Web Site</Tooltip>}
          >
            <div className="expand-body-icons">
              <FontAwesomeIcon
                color="white"
                icon={light('globe')}
                onClick={() => iconOnClick('globe')}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement={'bottom'}
            overlay={<Tooltip>Bank Account</Tooltip>}
          >
            <div className="expand-body-icons">
              <FontAwesomeIcon
                color="white"
                icon={light('money-check-dollar')}
                onClick={() => iconOnClick('money-check-dollar')}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement={'bottom'}
            overlay={<Tooltip>ID Profile</Tooltip>}
          >
            <div className="expand-body-icons">
              <FontAwesomeIcon
                color="white"
                icon={light('id-card')}
                onClick={() => iconOnClick('id-card')}
              />
            </div>
          </OverlayTrigger>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ExpandableCard;
